import React, { useEffect, useState, useRef } from "react";
import { FaPenToSquare, FaEye, FaDownload, FaArrowRight, FaArrowLeft, FaCheck, FaX } from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import "./css/Documentos.css";

const Documentos = () => {
  const [documentos, setDocumentos] = useState([
    { id: 1, nombre: "DUDASPASAPORTE.pdf", url: "/pdf/DUDASPASAPORTE.pdf" },
    { id: 2, nombre: "archivo_2.pdf", url: "/pdfs/archivo_2.pdf" },
    { id: 3, nombre: "archivo_3.pdf", url: "/pdfs/archivo_3.pdf" },
    { id: 4, nombre: "archivo_4.pdf", url: "/pdfs/archivo_4.pdf" },
    { id: 5, nombre: "archivo_5.pdf", url: "/pdfs/archivo_5.pdf" }
  ]);

  const [editingId, setEditingId] = useState(null);
  const [nuevoNombre, setNuevoNombre] = useState("");

  const handleView = (url) => {
    window.open(url, "_blank");
  };

  const handleDownload = (url, nombre) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = nombre;
    link.click();
  };

  const handleEditClick = (id, nombreActual) => {
    const nombreSinExtension = nombreActual.replace(/\.pdf$/i, ""); // quita .pdf
    setEditingId(id);
    setNuevoNombre(nombreSinExtension);
  };

  const handleNombreChange = (e) => {
    setNuevoNombre(e.target.value);
  };

  const handleSave = (id) => {
    const nombreFinal = `${nuevoNombre}.pdf`;

    setDocumentos((prev) =>
      prev.map((doc) =>
        doc.id === id ? { ...doc, nombre: nombreFinal } : doc
      )
    );

    setEditingId(null);
  };
  
  const handleCancel = () => {
    setEditingId(null);
    setNuevoNombre("");
  };

  const [pdfFile, setPdfFile] = useState(null);
  const inputRef = useRef(null);

  // Evita que por defecto se abra el archivo al arrastrarlo
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // Se activa al soltar el archivo en el área verde
  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const droppedFile = e.dataTransfer.files[0];
      
      // Verifica que sea un PDF
      if (droppedFile.type === "application/pdf") {
        setPdfFile(droppedFile);
      } else {
        alert("Por favor, sube solo archivos PDF");
      }
    }
  };

  // handleFileChange permite seleccionar el archivo y handleButtonClick hace que parezca que se hace desde el botón "Subir documento pdf"
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setPdfFile(file);
    } else {
      alert("Por favor, sube solo archivos PDF");
    }
  };

  const handleButtonClick = () => {
    inputRef.current.click();
  };

  useEffect(() => {
    if (pdfFile) {
      const nuevoDocumento = {
        id: Date.now(), // ID único
        nombre: pdfFile.name,
        url: URL.createObjectURL(pdfFile) // crea una URL temporal para previsualizar o descargar
      };
  
      setDocumentos(prev => [...prev, nuevoDocumento]);
      setPdfFile(null); // limpia el archivo cargado para que el área verde se resetee
    }
  }, [pdfFile]);
  
  
  return (
    <>
        <Navbar />
        
        <main className="main-user documentos ">
          <h1 className="titulo-user align-center">REPOSITORIO DE DOCUMENTOS PDF</h1> 

          <section className="between mt-50">

            {/* Listado documentos - Columna izquierda */}
            <div className="listado-documentos column">
              {documentos.map((doc) => (
                <div key={doc.id} className="documento between">
                  {editingId === doc.id ? (
                    <div>
                      <div className="between w-100">
                        <input className="w-400"
                          type="text"
                          value={nuevoNombre}
                          onChange={handleNombreChange}
                        />
                        <div className="check flex gap-5 mt-5">
                          <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSave(doc.id)}><FaCheck /></button>
                          <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={handleCancel}><FaX /></button>
                        </div>
                      </div>
                    </div>

                  ) : (
                    <p>{doc.nombre}</p>
                  )}

                  <div className="align-center verde iconos ml-5">
                    <FaEye aria-label="Ver el documento" className="cursor" onClick={() => handleView(doc.url)} />
                    <FaPenToSquare aria-label="Editar el nombre del documento" className="cursor" onClick={() => handleEditClick(doc.id, doc.nombre)} />
                    <FaDownload aria-label="Descargar el documento" className="cursor" onClick={() => handleDownload(doc.url, doc.nombre)} />
                  </div>
                </div>
              ))}
            </div>

            {/* Subir archivos - Columna derecha */}
            <div className="subir-documento">

              {/* Cuadro verde */}
              <div className="area-verde w-100 align-center" onDragOver={handleDragOver} onDrop={handleDrop}>
                {pdfFile ? (
                  <p>{pdfFile.name}</p>
                ) : (
                  <><FaArrowRight /><p>Arrastra y suelta <br></br>el archivo PDF aquí</p><FaArrowLeft /></>
                )}
              </div>

              {/* Botón subir documento */}
              <button onClick={handleButtonClick} className="boton">Subir documento pdf</button>
              <input ref={inputRef}
                type="file"
                accept="application/pdf"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>
          
          </section>

        </main>
    </>
  );
};

export default Documentos;